import each from 'lodash/each';
import transform from 'lodash/transform';

export const canResumeCase = uri => {
  const caseUriItems = parseUri(uri);

  return caseUriItems && caseUriItems.caseType === 'bsap';
};

export const parseCaseUri = uri => {
  const caseUriObj = parseUri(uri);

  if (uri && caseUriObj) {
    return {
      caseType: caseUriObj.caseSubType === 'existing/newbusiness' ? 'existing' : 'ntb',
      isExistingCustomer: caseUriObj.caseSubType === 'existing/newbusiness' ? 'Yes' : 'No',
      caseId: caseUriObj.caseId
    };
  }

  return null;
};

export const parseUri = uri => {
  const taskTypeMatch = uri.match(/^([\w]*):\/\//);

  if (!taskTypeMatch) {
    return undefined;
  }

  const uriObj = { type: taskTypeMatch[1] };
  let match;

  switch (uriObj.type) {
    case 'task':
      match = uri.match(/^[\w]*:\/\/([\w\d]*)\/([\w\d]*)(\/([\w\d]*))?\?(.*)/);
      if (match) {
        uriObj.caseType = match[1];
        uriObj.task = match[2];
        uriObj.action = match[4];

        const queryString = match[5];
        const queryStringArr = queryString.split('&');

        // Loop through each query string parameter and assign to uriObj
        each(queryStringArr, queryStringItem => {
          const queryStringItemArr = queryStringItem.split('=');
          if (queryStringItemArr.length === 2) {
            uriObj[queryStringItemArr[0]] = queryStringItemArr[1];
          }
        });
      }
      break;
    case 'case':
      if (uri.indexOf('existing/newbusiness') >= 0) {
        match = uri.match(/^[\w]*:\/\/([\w\d]*)\/([\w\d]*)\/([\w\d]*)\/([\w\d-]*)/);
        if (match) {
          uriObj.caseType = match[1];
          uriObj.caseSubType = match[2].concat('/').concat(match[3]);
          uriObj.caseId = match[4];
        }
      } else {
        match = uri.match(/^[\w]*:\/\/([\w\d]*)\/([\w\d]*)\/([\w\d-]*)/);
        if (match) {
          uriObj.caseType = match[1];
          uriObj.caseSubType = match[2];
          uriObj.caseId = match[3];
        }
      }
      break;
    default:
      break;
  }

  return transform(uriObj, (result, val, key) => {
    const next = result;
    next[key] = val && key !== 'caseId' ? val.toLowerCase() : val;

    return next;
  });
};
